<template>
  <div>
    <img src="../assets/images/note-added.svg" :style="{width: '22px', cursor: 'pointer'}" @click="toggle()"/>
    <div class="notes-popup-overlay" v-if="show">
      <div class="notes-popup-container" >
        <div class="title">Note for {{title}}</div>
        <div class="close-btn"><img src="../assets/images/close-btn.svg" @click="close()"/></div>
        <div class="divi-line"></div>
        <!-- <textarea class="notes-input" placeholder="please type here" @input="evt => handleInput(evt)" :value="value"></textarea> -->
        <div class="notes-input">{{value}}</div>
        <div class="save-btn-container">
          <!-- <button class="save-btn" @click="close()">Save</button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotesPopup',
  props: {
    id: {
      type: [String, Number],
      required: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    defaultValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    defaultValue(newDefaultValue,oldDefaultValue){
      this.value = newDefaultValue;
    },
  },
  data() {
    return {
      show: false,
      value: ''
    }
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    close() {
      this.show = false;
    },
    handleInput(evt) {
      this.value = evt.target.value;
      this.$emit('updateNote', this.value, this.id);
    }
  },
  mounted() {
    this.value = this.defaultValue;
  }
}
</script>
<style lang="scss" scoped>
.notes-popup-overlay {
  position: fixed;
  width: 1080px;
  height: 800px;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
}
.notes-popup-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  max-width: 800px;
  max-height: 600px;
  background-color: #E4F4F9;
  border-radius: 50px;
  border-top-right-radius: 0px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.26);
  z-index: 11;
  padding-top: 40px;
  padding-left: 25px;
}

.title {
  position: absolute;
  left: 40px;
  top: 30px;
  font-size: 18px;
  font-weight: bold;
  color: #1381A2;
}

.notes-input {
  width: 95%;
  height: 88%;
  border: none;
  outline: none;
  background-color: #E4F4F9;
  font-size: 15px;
  padding: 15px;
  border-radius: 15px;
}

.divi-line {
  width: calc(100% - 40px);
  height: 1px;
  background-color: #1381A2;
  margin-top: 20px;
  margin-left: 12px;
}

.close-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
}

.save-btn-container {
  position: absolute;
  bottom: 15px;
  right: 40px;
}

.save-btn {
  border: none;
  width: 68px;
  cursor: pointer;
  height: 25px;
  background: #1381A2;
  color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 12px;
  opacity: 1;
  font-size: 12px;
}
</style>